(() => {
  const localized = value => { const field = document.createElement('textarea'); field.innerHTML = value || ''; return field.value; };
  const text = (pattern, values) => Object.entries(values).reduce((value, [key, replacement]) => value.replace(`{${key}}`, replacement), localized(pattern));
  function information(root) {
    const description = document.querySelector('[data-product-description]');
    const wrapper = description?.closest('.shopify-section');
    const hero = root.querySelector('.ww-flow-hero');
    if (!wrapper || !hero) return;
    const heading = description.querySelector('.text-section__heading');
    const label = localized(root.querySelector('.ww-flow-order')?.dataset.informationLabel);
    if (heading && label && heading.textContent.trim() !== label) heading.textContent = label;
    const slot = root.querySelector('[data-ww-flow-information-slot]');
    const desktopSlot = window.matchMedia('(min-width: 992px)').matches && slot && !wrapper.querySelector('form');
    const target = desktopSlot ? slot : root;
    if (wrapper.parentElement !== target) {
      wrapper.classList.add('ww-flow-information');
      if (desktopSlot) slot.append(wrapper);
      else {
        const form = root.querySelector('form.product-form[data-template="true"]');
        (form || hero).after(wrapper);
      }
      description.classList.remove('js-animate');
    }
    const panels = description.querySelectorAll('.ww-info-disclosure');
    if (panels.length && !description.dataset.flowPanelsReady) {
      panels.forEach((panel, index) => {
        const heading = panel.querySelector('summary')?.textContent || '';
        panel.open = index === 0 || /zertifiz|certific/i.test(heading);
      });
      description.dataset.flowPanelsReady = 'true';
    }
  }
  function compactDelivery(root) {
    const host = root.querySelector('.ww-flow-fulfillment');
    if (host?.closest('form')?.dataset.wwSupplierActive === 'true') return;
    const panel = host?.querySelector('.ww-delivery-panel');
    const app = panel?.querySelector('.shopify-app-block');
    if (panel) {
      const notice = root.querySelector('.product-notice-custom');
      if (notice && !notice.closest('.ww-flow-delivery-special')) {
        const box = document.createElement('div');
        box.className = 'ww-flow-delivery-special';
        const label = document.createElement('strong');
        label.textContent = localized(host.dataset.specialDelivery);
        const previous = notice.parentElement;
        box.append(label, notice);
        if (previous.matches('.product-custom-liquid') && !previous.textContent.trim()) previous.classList.add('ww-flow-empty-help');
        panel.append(box);
      }
    }
    const message = app?.querySelector('.delivery_msg');
    if (!message) return;
    const source = message.textContent.replace(/\s+/g, ' ');
    const dates = Array.from(message.querySelectorAll('.hightlight_date')).map(date => date.textContent.trim());
    const limit = source.match(/MIT\s+DRUCK\s+bis\s+(\d+)\s+Stück/i);
    const valid = /ARTIKEL\s+DIREKT\s+LIEFERBAR/i.test(source) && /OHNE\s+Druck/i.test(source) && limit && dates.length === 4 && dates.every(date => /^\d{1,2}\.\d{1,2}\.\d{2,4}$/.test(date));
    let preview = panel.querySelector('.ww-flow-delivery-compact');
    let details = panel.querySelector('.ww-flow-delivery-details');
    if (!valid) {
      if (preview && !preview.hidden) preview.hidden = true;
      if (details) {
        if (!details.open) details.open = true;
        if (!details.querySelector('summary').hidden) details.querySelector('summary').hidden = true;
        details.dataset.fallback = 'true';
      }
      return;
    }
    if (!preview) {
      preview = document.createElement('div');
      preview.className = 'ww-flow-delivery-compact';
      const status = document.createElement('p');
      status.className = 'ww-flow-delivery-status';
      status.textContent = localized(host.dataset.deliveryAvailable);
      const list = document.createElement('dl');
      for (let i = 0; i < 2; i++) {
        const row = document.createElement('div');
        row.append(document.createElement('dt'), document.createElement('dd'));
        list.append(row);
      }
      preview.append(status, list);
      details = document.createElement('details');
      details.className = 'ww-flow-delivery-details';
      const summary = document.createElement('summary');
      summary.textContent = localized(host.dataset.deliveryNotes);
      app.before(preview, details);
      details.append(summary, app);
    }
    if (preview.hidden) preview.hidden = false;
    if (details.dataset.fallback) {
      details.open = false;
      details.querySelector('summary').hidden = false;
      delete details.dataset.fallback;
    }
    const values = [localized(host.dataset.deliveryUnprinted), dates.slice(0,2).join(' – '), text(host.dataset.deliveryPrinted, { quantity:limit[1] }), dates.slice(2,4).join(' – ')];
    preview.querySelectorAll('dt, dd').forEach((node, index) => { if (node.textContent !== values[index]) node.textContent = values[index]; });
  }
  function arrangeVariantHelp(form) {
    const selection = form.querySelector('.ww-flow-selection');
    if (!selection) return;
    const pairs = [
      ['input[data-option="Größe"],input[data-option="Size"]', '.product-options__size-guide'],
      ['input[data-option="Farbe"],input[data-option="Color"],input[data-option="Colour"]', '.custom-options-wrapper']
    ];
    pairs.forEach(([fieldSelector, helpSelector]) => {
      const field = selection.querySelector(fieldSelector);
      const option = field?.closest('.product-options__swatch,.product-options__default');
      const label = option?.querySelector('.product-options__option-label');
      const help = selection.querySelector(helpSelector);
      if (!label || !help) return;
      let row = label.closest('.ww-flow-option-heading');
      if (!row) {
        row = document.createElement('div');
        row.className = 'ww-flow-option-heading';
        label.before(row);
        row.append(label);
      }
      if (help.parentElement !== row) {
        const previous = help.parentElement;
        row.append(help);
        if (previous.matches('.product-custom-liquid') && !previous.querySelector('a,button,input,p')) previous.classList.add('ww-flow-empty-help');
      }
    });
  }
  function emphasizePrintChoice(form) {
    const section = form.querySelector('.ww-flow-personalize');
    const choice = section?.querySelector('input[name="Mit oder ohne Druck?"]');
    const group = choice?.closest('.gpo-element');
    if (!group) return;
    if (!group.classList.contains('ww-flow-print-choice')) group.classList.add('ww-flow-print-choice');
    if (!group.querySelector('.ww-flow-choice-hint')) {
      const hint = document.createElement('p');
      hint.className = 'ww-flow-choice-hint';
      hint.textContent = localized(section.dataset.choiceHint);
      const label = group.querySelector('.gpo-label');
      if (label) label.after(hint);
      else group.prepend(hint);
    }
  }
  function tierWindow(root, form, tiers, chips, input) {
    const host = form.querySelector('[data-ww-tier-window]');
    const cards = host?.querySelector('[data-ww-tier-cards]');
    const progress = host?.querySelector('[data-ww-tier-progress]');
    if (!host || !cards || !progress) return;
    const german = /^de(?:-|$)/i.test(document.documentElement.lang || 'de');
    const quantity = Number(input?.value);
    const valid = input && input.value.trim() !== '' && input.validity.valid && Number.isSafeInteger(quantity) && quantity > 0;
    const current = valid ? tiers.find(tier => quantity >= tier.min && quantity <= tier.max) : null;
    const upcoming = valid ? tiers.filter(tier => tier.min > quantity).slice(0, 2) : [];
    const priceOf = tier => {
      const chip = tier && chips.querySelector(`[data-min="${tier.min}"]`);
      return tier ? { gross:chip?.querySelector('.ww-flow-chip-gross')?.textContent || '—', net:chip?.querySelector('.ww-flow-chip-net')?.textContent || '', disabled:chip?.disabled !== false } : {
        gross: `${form.querySelector('[data-ww-unit-base-gross]')?.textContent || '—'} ${form.querySelector('[data-ww-unit-gross-label]')?.textContent || ''}`.trim(),
        net: form.querySelector('[data-ww-unit-net-column]')?.hidden ? '' : `${form.querySelector('[data-ww-unit-base-net]')?.textContent || '—'} ${root.querySelector('.ww-flow-order')?.dataset.netLabel || ''}`.trim(), disabled:false
      };
    };
    const entries = valid ? [{ label:current ? (german ? `Aktuell ab ${current.min}` : `Current from ${current.min}`) : (german ? 'Aktuell' : 'Current'), current:true, percent:current?.percent || 0, ...priceOf(current) },
      ...upcoming.map(tier => ({ label:german ? `Ab ${tier.min} Stück` : `From ${tier.min} items`, min:tier.min, percent:tier.percent, ...priceOf(tier) }))] : [
      { label:german ? 'Aktuell' : 'Current', current:true, gross:'—', net:'', percent:0 }
    ];
    const signature = JSON.stringify(entries);
    if (cards.dataset.signature !== signature) {
      const fragment = document.createDocumentFragment();
      entries.forEach(entry => {
        const card = document.createElement(entry.current ? 'div' : 'button');
        card.className = 'ww-flow-tier-card';
        if (entry.current) card.classList.add('is-current');
        else { card.type = 'button'; card.dataset.min = entry.min; card.disabled = entry.disabled; }
        const label = document.createElement('span'); label.className = 'ww-flow-tier-label'; label.textContent = entry.label;
        const percent = document.createElement('span'); percent.className = 'ww-flow-tier-percent'; percent.textContent = entry.percent ? `−${entry.percent} %` : (german ? 'Grundpreis' : 'Base price');
        const gross = document.createElement('strong'); gross.textContent = entry.gross;
        const net = document.createElement('small'); net.textContent = entry.net; net.hidden = !entry.net;
        card.append(label, percent, gross, net); fragment.append(card);
      });
      cards.replaceChildren(fragment); cards.dataset.signature = signature; cards.dataset.count = entries.length;
    }
    const first = upcoming[0];
    const allowed = first && !priceOf(first).disabled;
    const message = !valid ? (german ? 'Bitte eine gültige Menge wählen.' : 'Please select a valid quantity.') : first && allowed ?
      (german ? `Noch ${first.min - quantity} Stück bis ${first.percent} % Mengenrabatt.` : `${first.min - quantity} more items to reach ${first.percent}% quantity discount.`) : first ?
      (german ? 'Weitere Staffelpreise finden Sie in der vollständigen Übersicht.' : 'See the full overview for more price tiers.') :
      (german ? 'Sie nutzen bereits die höchste Mengenrabattstufe.' : 'You already qualify for the highest quantity discount.');
    if (progress.textContent !== message) progress.textContent = message;
    if (host.hidden) host.hidden = false;
  }

  function structurePrint(form) {
    const panel = form.querySelector('.ww-flow-personalize');
    if (!panel) return;
    const german = document.documentElement.lang.startsWith('de');
    const stages = [
      { names: /^(Design übernehmen\?|Reuse design\?)$/i, title: german ? 'Design übermitteln' : 'Provide your design', number: '1' },
      { names: /^(Druckart|Print type)$/i, title: german ? 'Druck festlegen' : 'Choose printing', number: '2' },
      { names: /^(Freigabe oder Vorschau\?|Approval or preview\?)$/i, title: german ? 'Freigabe' : 'Approval', number: '3' }
    ];
    const fields = Array.from(panel.querySelectorAll('.gpo-element'));
    stages.forEach(stage => {
      const field = fields.find(element => Array.from(element.querySelectorAll('input,select,textarea')).some(input => stage.names.test(input.name)));
      if (!field || field.querySelector('.ww-flow-print-stage-heading')) return;
      field.classList.add('ww-flow-print-stage');
      const heading = document.createElement('h3');
      heading.className = 'ww-flow-print-stage-heading';
      const number = document.createElement('span');
      number.setAttribute('aria-hidden', 'true');
      number.textContent = stage.number;
      heading.append(number, document.createTextNode(stage.title));
      field.prepend(heading);
    });
  }
  function stickySelection(root) {
    const column = root.querySelector('.ww-flow-variant-column');
    if (!column || column.dataset.wwStickyReady) return;
    const header = document.querySelector('.header-section');
    const update = () => {
      const height = Math.ceil(column.getBoundingClientRect().height);
      const headerPosition = header && getComputedStyle(header).position;
      const top = header && /^(sticky|fixed)$/.test(headerPosition) ? Math.ceil(header.getBoundingClientRect().height) + 16 : 16;
      column.style.setProperty('--ww-variant-height', `${height}px`);
      column.style.setProperty('--ww-selection-top', `${top}px`);
    };
    update();
    column.dataset.wwStickyReady = 'true';
    const observer = new ResizeObserver(update);
    observer.observe(column);
    if (header) observer.observe(header);
  }

  function manufacturerSelection(root) {
    const selection = root.querySelector('[data-ww-manufacturer-selection]');
    if (!selection) return;
    const value = selection.querySelector('[data-ww-manufacturer-value]');
    const form = selection.closest('form');
    const variantId = form?.querySelector('[data-js-product-variant] select[name="id"]')?.value;
    const details = Array.from(document.querySelectorAll('[data-ww-manufacturer-product]'))
      .find(element => element.dataset.wwManufacturerProduct === selection.dataset.productId);
    const rows = details ? Array.from(details.querySelectorAll('[data-ww-manufacturer-variant]')) : [];
    const selected = [1, 2, 3].map(position => {
      const controls = Array.from(form.querySelectorAll(`.product-options [name="option${position}"]`));
      return controls.find(input => input.matches('select') || input.checked)?.value;
    });
    const hasOptions = selected.some(value => value !== undefined);
    const row = hasOptions
      ? rows.find(candidate => [1, 2, 3].every(position => {
          const expected = candidate.getAttribute(`data-option-${position}`);
          return !expected || expected === selected[position - 1];
        }))
      : rows.find(candidate => candidate.dataset.wwManufacturerVariant === variantId);
    const valid = Boolean(row);
    const next = valid ? row.querySelector('td')?.textContent.trim() : '';
    if (value && value.textContent !== next) value.textContent = next;
    selection.hidden = !next;
  }

  function enhance(root) {
    manufacturerSelection(root);
    if (!root.classList.contains('ww-flow-product')) return;
    information(root);
    const form = root.querySelector('form.product-form[data-template="true"]');
    const order = form?.querySelector('.ww-flow-order');
    if (!form || !order) return;
    compactDelivery(root);
    emphasizePrintChoice(form);
    arrangeVariantHelp(form);
    structurePrint(form);
    stickySelection(root);
    const printEntry = root.querySelector('.ww-flow-print-entry');
    const printAvailable = Boolean(form.querySelector('.ww-flow-personalize input[name="Mit oder ohne Druck?"]'));
    if (printEntry && root.dataset.wwReservePrint !== 'true' && printEntry.hidden === printAvailable) printEntry.hidden = !printAvailable;
    const group = form.querySelector('.gpo-group__header .group-label');
    if (group && /konfigurator|configurator/i.test(group.textContent) && group.textContent !== localized(order.dataset.personalizeLabel)) group.textContent = localized(order.dataset.personalizeLabel);
    form.querySelectorAll('.gpo-heading').forEach(heading => {
      if (/^Bitte die Menge wählen und in den Warenkorb legen$/i.test(heading.textContent.trim())) heading.closest('.gpo-element')?.classList.add('ww-flow-redundant-hint');
    });
    const tableBlock = form.querySelector('#lb-volume-discount');
    const table = tableBlock?.querySelector('table');
    if (!table) return;
    if (!tableBlock.closest('.ww-flow-tiers')) {
      const details = document.createElement('details');
      details.className = 'ww-flow-tiers';
      const summary = document.createElement('summary');
      summary.textContent = order.dataset.tiersLabel;
      tableBlock.before(details);
      details.append(summary, tableBlock);
    }
    const tiers = Array.from(table.querySelectorAll('tbody tr')).map(row => {
      const cells = row.querySelectorAll('td');
      const range = cells[0]?.textContent.match(/\d[\d\s.,]*/g);
      const percent = cells[1]?.textContent.match(/(\d+(?:[.,]\d+)?)\s*%/);
      if (!range || !percent) return null;
      const min = Number(range[0].replace(/[^\d]/g, ''));
      const max = range[1] ? Number(range[1].replace(/[^\d]/g, '')) : Infinity;
      return { min, max, percent: Number(percent[1].replace(',', '.')), row };
    }).filter(tier => tier && Number.isFinite(tier.min) && tier.percent > 0);
    const preview = root.querySelector('[data-ww-flow-discount-preview]');
    const chips = root.querySelector('[data-ww-flow-discount-chips]');
    if (!preview || !chips || !tiers.length) return;
    const signature = JSON.stringify(tiers.map(({ min, max, percent }) => ({ min, max, percent })));
    if (chips.dataset.tiers !== signature) {
      const fragment = document.createDocumentFragment();
      tiers.forEach(tier => {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'ww-flow-discount-chip';
        chip.dataset.min = tier.min;
        chip.dataset.max = tier.max;
        const label = document.createElement('span');
        const value = document.createElement('strong');
        label.textContent = text(order.dataset.discountFrom, { quantity: tier.min });
        value.textContent = `−${tier.percent} %`;
        const prices = document.createElement('span');
        prices.className = 'ww-flow-chip-prices';
        const gross = document.createElement('span');
        gross.className = 'ww-flow-chip-gross';
        const net = document.createElement('span');
        net.className = 'ww-flow-chip-net';
        prices.append(gross, net);
        chip.append(label, value, prices);
        fragment.append(chip);
      });
      chips.replaceChildren(fragment);
      chips.dataset.tiers = signature;
      preview.hidden = false;
      const hint = root.querySelector('[data-ww-flow-discount-hint]');
      if (hint) {
        hint.textContent = text(order.dataset.discountUpTo, { percent: Math.max(...tiers.map(tier => tier.percent)) });
        hint.hidden = false;
      }
    }
    const input = form.querySelector('input[name="quantity"][data-quantity-input]');
    const quantity = Number(input?.value || 1);
    chips.querySelectorAll('[data-min]').forEach((chip, index) => {
      const tier = tiers[index];
      const grossCell = tier.row.querySelector('[data-ww-tier-gross]');
      const netCell = tier.row.querySelector('[data-ww-tier-net]');
      const gross = chip.querySelector('.ww-flow-chip-gross');
      const net = chip.querySelector('.ww-flow-chip-net');
      const grossText = grossCell?.textContent.trim();
      const grossValue = grossText && grossText !== '—' ? `${grossText} ${localized(form.querySelector('[data-ww-unit-gross-label]')?.textContent || order.dataset.grossLabel)}` : '—';
      const netValue = netCell && !netCell.hidden ? `${netCell.textContent.trim()} ${localized(order.dataset.netLabel)}` : '';
      if (gross.textContent !== grossValue) gross.textContent = grossValue;
      if (net.textContent !== netValue) net.textContent = netValue;
      if (net.hidden !== !netValue) net.hidden = !netValue;
      const minimum = Number(input?.min || 1);
      const maximum = input?.max ? Number(input.max) : Infinity;
      const step = input?.step === 'any' ? 1 : Number(input?.step || 1);
      const allowed = input && !input.disabled && !input.readOnly && tier.min >= minimum && tier.min <= maximum && Number.isInteger((tier.min - minimum) / step);
      const disabled = !allowed || !grossText || grossText === '—';
      if (chip.disabled !== disabled) chip.disabled = disabled;
      const active = quantity >= Number(chip.dataset.min) && quantity <= Number(chip.dataset.max);
      if (chip.classList.contains('is-active') !== active) chip.classList.toggle('is-active', active);
      if (chip.getAttribute('aria-pressed') !== String(active)) chip.setAttribute('aria-pressed', String(active));
    });
    tierWindow(root, form, tiers, chips, input);
  }
  function init() {
    document.querySelectorAll('section.product[data-section-type="product"]').forEach(root => {
      if (root.dataset.flowEnhanced) return;
      root.dataset.flowEnhanced = 'true';
      let queued = false;
      const schedule = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => { queued = false; enhance(root); });
      };
      new MutationObserver(schedule).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'disabled'] });
      root.addEventListener('click', event => {
        const chip = event.target.closest('.ww-flow-discount-chip,button.ww-flow-tier-card[data-min]');
        if (!chip || chip.disabled || !root.contains(chip)) return;
        const input = root.querySelector('form.product-form[data-template="true"] input[name="quantity"][data-quantity-input]');
        if (!input || input.disabled || input.readOnly) return;
        const previous = input.value;
        input.value = chip.dataset.min;
        if (!input.validity.valid) { input.value = previous; return; }
        input.dispatchEvent(new Event('input', { bubbles:true }));
        input.dispatchEvent(new Event('change', { bubbles:true }));
        schedule();
      });
      root.addEventListener('input', schedule);
      root.addEventListener('change', schedule);
      document.addEventListener('product:variant:change', schedule);
      window.addEventListener('resize', schedule, { passive: true });
      schedule();
    });
  }
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once:true });
  else init();
})();












